
import EsQuery from '@/javascript/esQuery'
import vPinyin from '@/javascript/vue-py'
import Tab from 'vux/src/components/tab/tab.vue'
import TabItem from 'vux/src/components/tab/tab-item.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import Cpts020 from '@/components/lyx-components/cpts020/index.vue'
import bus from '@/javascript/bus'

export default {
components: {
Tab,
TabItem,
Actionsheet,
Cpts020
},
data() {
return {
minHeight: 0,
getDetails: [],
cityName: [],
thisScreen: [],
strategy: [],
dayList: {},
isTop: false,
tabIndex: 3,
leftLayer: false,
rightLayer: true,
sendId: '',
tabItems: [],
userId: bus.userInfo.user.id,
}
},
mounted() {
this.minHeight = document.documentElement.clientHeight
const _this = this
window.addEventListener('scroll', _this.windowScroll)

_this.$http.get('/getVisitor/planDetails?id=' + this.senId + '&userId=' + this.userId).then((response1) => {
_this.dayList = response1.data.data
_this.getDetails = response1.data.data.planDetail.cityList
}).then(() => {
document.title = _this.dayList.title

_this.$http.get(_this.STATIC_BASE_URL + '/json/cityName.json').then((response2) => {
const cityName = response2.data
this.$set(_this, 'cityName', cityName)
const screen = []
_this.getDetails.forEach(item => {
if (item.level == 2) {
const strategyEsQuery = new EsQuery()
strategyEsQuery.addString("title", cityName[item.name], strategyEsQuery.and, true)
.addString('kind', '1', strategyEsQuery.and, false)
const strategyEsJsonQuery = JSON.stringify(strategyEsQuery.getArray())
this.$http.get('/strategy/query?esJsonQuery=' + encodeURI(strategyEsJsonQuery)).then((response) => {
if (response.data.data !== null && response.data.data.length > 0) {
_this.strategy.push({
strategyId: response.data.data[0]._id,
catalog: response.data.data[0]._source.catalog,
description: response.data.data[0]._source.catalog[0].description,
screen: cityName[item.name],
pname: vPinyin.chineseToPinYin(cityName[item.name]).toLowerCase(),
strategyCode: item.code + '00'
})
}
}).then(() => {
let obj = {};
_this.strategy = _this.strategy.reduce(function(item, next) {
obj[next.screen] ? '' : obj[next.screen] = true && item.push(next);
return item;
}, []);
})
}
})
})
})
},
methods: {
windowScroll: function () {
const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
if (this.$refs.top && scrollTop >= this.$refs.top.offsetTop) {
this.isTop = true
} else {
this.isTop = false
}
},
tabHandler: function (index) {
this.$router.replace({path: this.tabItems[index].routerLink + this.senId})
},
},
created() {
this.senId = this.$route.params.id
this.tabItems = [{
name: '概要',
routerLink: '/travel-profile/'
}, {
name: '详情',
routerLink: '/travel-details/0/',
}, {
name: '地图',
routerLink: '/map-days/'
},




]
}
}
